import Layout from '@/layout'

const reservationRouter = {
  path: '/reservation',
  component: Layout,
  redirect: '/reservation/search_reservation',
  // name: 'Nested',
  meta: {
    title: 'Đặt phòng'
  },
  children: [
    {
      path: 'new_reservation',
      component: () => import('@/views/mci/reservation/pages/BookingPage.vue'),
      name: 'reservation.new_reservation',
      meta: { title: 'Tạo đặt phòng' }
    },
    {
      path: 'search_reservation',
      // component: () => import('@/views/mci/reception/ArrivalGuest.vue'),
      component: () =>
        import('@/views/mci/reservation/pages/ListReservationsPage.vue'),
      name: 'reservation.search_reservation',
      meta: { title: 'Tìm kiếm đặt phòng' }
    },
    // {
    //   path: 'list_task',
    //   component: () =>
    //     import('@/views/mci/reservation/pages/ListTasksPage.vue'),
    //   name: 'reservation.list_task',
    //   meta: { title: 'Tìm kiếm đặt phòng' }
    // },
    {
      path: 'future_availability',
      component: () =>
        import('@/views/mci/reservation/pages/FutureAvailabilityPage.vue'),
      name: 'reservation.future_availability',
      meta: { title: 'Tình trạng phòng trống' }
    },
    {
      path: 'post_transaction',
      component: () =>
        import('@/views/mci/reservation/pages/PostTransaction.vue'),
      name: 'reservation.post_transaction',
      meta: { title: 'Giao dịch' }
    },
    {
      path: 'reservation_status',
      component: () =>
        import('@/views/mci/reservation/pages/ReservationStatusPage.vue'),
      name: 'reservation.reservation_status',
      meta: { title: 'Trạng thái đặt phòng' }
    },
    {
      path: 'assign_guest_information',
      component: () =>
        import('@/views/mci/reservation/pages/AssignGuestInformationPage.vue'),
      name: 'reservation.assign_guest_information',
      meta: { title: 'Gán phòng' }
    }
  ]
}

export default reservationRouter
